// extracted by mini-css-extract-plugin
export default {"control":"NavbarLinksGroup_control__YHU+t","link":"NavbarLinksGroup_link__ZvqZg","chevron":"NavbarLinksGroup_chevron__HqmZo"};